export type RemittanceDateOfPayment = {
  from: string;
  to: string;
};

const ISO_DAY = /^\d{4}-\d{2}-\d{2}$/;

export function isIsoDay(value: string): boolean {
  return ISO_DAY.test(value);
}

export function isCompleteOrderedRemittanceRange(range: RemittanceDateOfPayment): boolean {
  return isIsoDay(range.from) && isIsoDay(range.to) && range.from <= range.to;
}

export function nextRemittanceDateOfPayment(
  current: RemittanceDateOfPayment,
  field: keyof RemittanceDateOfPayment,
  date: string,
): RemittanceDateOfPayment | null {
  if (date === '') {
    return { ...current, [field]: date };
  }

  if (!isIsoDay(date)) {
    return null;
  }

  const next = { ...current, [field]: date };

  if (isIsoDay(next.from) && isIsoDay(next.to) && next.from > next.to) {
    return null;
  }

  return next;
}
